import type { Country } from '../../constants/country/country';
import type { Currency } from '../../constants/currency/currency';

export type ShippingDuration = {
  /** Minimum delivery days */
  minDay: number;
  /** Maximum delivery days */
  maxDay: number;
};

export type DeliveryDateRange = {
  /** Minimum delivery date in ISO format (YYYY-MM-DD) */
  minDate: string;
  /** Maximum delivery date in ISO format (YYYY-MM-DD) */
  maxDate: string;
};

export type ShippingPolicyItem = {
  /** Country code */
  countryCode: Country;
  /** Currency code */
  currencyCode: Currency;
  /** Shipping fee amount */
  shippingFee: number;
  /** Free shipping threshold amount */
  freeShippingThreshold: number;
  /** Shipping duration */
  shippingDuration: ShippingDuration;
  /** Delivery date range from backend */
  deliveryDateRange?: DeliveryDateRange;
  /** SLA date in YYYYMMDD format */
  slaDate?: string;
};
